import React from 'react';
import {
  Button,
  IconButton,
  Paper,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Tooltip,
  Divider,
  Checkbox,
  InputLabel,
  MenuItem,
  FormControl,
  Select
} from '@mui/material';

import { Add, Delete, Edit } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, ConfirmDialog, TransferList, C, UploadFiles } from '../include';
import _ from 'underscore';

const strFillPattern = ". "

class EditQuestionnaire extends React.Component {
  constructor(props) {
    super(props); 
    
     

    this.state = { 
      questionnaireID: this.props.row ? this.props.row.id : -1,
      name: this.props.row ? this.props.row.name : '', 
      template_file_id: this.props.row ? this.props.row.template_file_id : -1, 
      previous_template_file_id: this.props.row ? this.props.row.template_file_id : -1, 
      type: this.props.row ? this.props.row.type : -1,
      questions_selected: null,
      questions_unselected: null
    };
  }



  componentDidMount() {
    var theID = this.props.row ? this.props.row.id : -1;
    this.setState({ loading: true });   
    this.props.api
      .get('/Questionnaire/' + theID)
      .then((r) => {
        var selected = [];
        var unselected = [];
        for(let row in r.selected){
          selected.push (r.selected[row].id + strFillPattern + r.selected[row].label );
        }
        for(let row in r.unselected){
          unselected.push( r.unselected[row].id + strFillPattern + r.unselected[row].label );
        }
        this.setState({
          questions_selected: selected,
          questions_unselected: unselected,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }
  
  

  handleSubmit = () => {
    var questionsIDs = [];
    for(var row in this.state.questions_selected){
          var v = this.state.questions_selected[row].split(strFillPattern)
          questionsIDs.push(v[0])
    }
    
    if (!this.props.edit) {
      this.props.api
        .post('/Questionnaires/', { name: this.state.name, template_file_id: this.state.template_file_id, type: this.state.type, questionsIDs: questionsIDs })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Registro criado com sucesso');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao criar o registro'));
    } else {
      this.props.api
        .put('/Questionnaire/' + this.props.row.id, { id: this.props.row.id, name: this.state.name, template_file_id: this.state.template_file_id, previous_template_file_id: this.state.previous_template_file_id, type: this.state.type, questionsIDs: questionsIDs })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert(r.message);
        })
        .catch(() => this.props.alert('Ocorreu um erro ao salvar alterações'));
    }
  };
  
    
  handleQuestionsChange = (v) => {
    this.setState({questions_selected: v})
  };
  

  handleDBRecord = (record, error) => {
    if(!error){
      this.setState({template_file_id: record.id });
    }
  }
  
  
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <DialogTitle style={{ minWidth: '400px' }}>
          {this.props.edit ? 'Editar Questionário' : 'Adicionar Questionário'}
        </DialogTitle>
        <DialogContent>
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Nome"
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })}
            required
          />
          <D h="1rem" />
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".pdf"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error) }}
            registerIntoDB={true}
            caption="Modelo de Documento"
          />
          <TextField
            fullWidth
            variant="outlined"
            label="Modelo"
            value={this.state.template_file_id}
            onChange={(e) => this.setState({ template_file_id: e.target.value })}
          />
          <D h="1rem" />
          <FormControl fullWidth>
            <InputLabel id="select-type">Tipo</InputLabel>
            <Select
              labelId="select-type"
              id="select-t"
              value={this.state.type}
              label="Tipo"
              onChange={(e) => this.setState({type: e.target.value})}
            >
              {Object.keys(C.DocumentType).map(key => {
                  return <MenuItem key={key} value={key}>{C.DocumentType[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <D h="1rem" />
          <FormControl fullWidth>
          { this.state.questions_selected && this.state.questions_unselected &&
            <TransferList
              caption="Perguntas" 
              alternative={this.state.questions_unselected}
              assignment={this.state.questions_selected}
              onAssignmentChange={this.handleQuestionsChange}
            />
          }
          </FormControl>
      
          <D h="2rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit">
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}

export class Questionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchField: '',
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === 'w'
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: 'id', headerName: 'ID', width: 70 },
      { field: 'name', headerName: 'Nome', width: 300 },
      { field: 'typestring', headerName: 'Tipo', width: 200 },
      { field: 'template_file_id', headerName: 'Modelo', width: 70 },
    ];
  }

  componentDidMount() {
    this.updateData();
  }

  updateData = (page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) => {
    this.setState({ loading: true });
    this.props.api
      .get('/Questionnaires', { params: { page, pageSize, search: searchField } })
      .then((r) => {
        for(var row in r.questionnaires){
          r.questionnaires[row]["typestring"] = C.DocumentType[ r.questionnaires[row]["type"] ];
          if(r.questionnaires[row]["template_file_id"] === "null")
            r.questionnaires[row]["template_file_id"] = -1;
          
        }
        this.setState({
          dataTable: r.questionnaires || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.includes(i) ? _.without(this.state.selectedRows, i) : _.union(this.state.selectedRows, [i])
    });
  };
  
  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <>              
              <Divider sx={{ paddingRight: '5px' }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length === 1 && (
                <>
                  <Tooltip title="Editar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <EditQuestionnaire
                            edit
                            row={this.state.selectedRows[0]}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              this.updateData();
                            }}
                          />
                        )
                      }
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              {this.state.selectedRows.length > 0 && (
                <>
                  <Tooltip title="Excluir selecionados" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <ConfirmDialog
                            title="Excluir Itens"
                            msg="Ao confirmar, os itens serão excluídos e não poderão ser recuperados"
                            reg={
                              this.state.selectedRows.length > 1
                                ? this.state.selectedRows.length + " registros selecionados"
                                : "1 registro selecionado"
                            }
                            onCancel={this.props.dialogClose}
                            onConfirm={() => {
                              for (let row of this.state.selectedRows) {
                                this.props.api
                                  .delete("/Questionnaire/" + row.id)
                                  .then((r) => {
                                    this.props.alert(r.message);
                                    this.props.dialogClose();
                                    this.setState({ selectedRows: [] });
                                    this.updateData();
                                  })
                                  .catch(() => this.props.alert("Ocorreu um erro ao excluir o registro"));
                              }
                            }}
                          />
                        )
                      }
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: '12px' }}
                  onClick={() =>
                    this.props.dialog(
                      <EditQuestionnaire
                        edit={false}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />

        <Paper sx={{ width: '100%', height: '800px', overflow: 'hidden' }}>
          <DataGrid
            rows={dataTable}
            columns={this.columns}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </Paper>
      </D>
    );
  }
}


